import React from "react";
import cx from "classnames";
import styles from "../../../../Styles/AppMetricDisplay.module.scss";

type Props = {
  metricValue: string;
  metricDescription: string;
  isHidden?: boolean;
};

export default class AppMetricDisplay extends React.Component<Props> {
  render() {
    return (
      <div className={cx([styles.appMetricDisplay, { [styles.hidden]: this.props.isHidden }])}>
        <p className={styles.appMetricValue}>{this.props.metricValue}</p>
        <p className={styles.appMetricDescription}>{this.props.metricDescription}</p>
      </div>
    );
  }
}
